<template>
  <div class="bg-FFFFFF" :class="{ bb: showBorder }">
    <div class="fb fb-main-between">
      <div
        class="fb fb-main-between fb-cross-center font-28 h-48 p-14-0 p-0-16 bb width-full item-flex-1 hidden-x"
      >
        <!-- 切换日期 -->
        <span class="item-shrink-0" @click="handlerToSelectDate"
          >{{ showDate
          }}<i class="iconfont c-171A1D font-24 pl-6">&#xe648;</i></span
        >
        <!-- 切换年级 -->
        <div
          class="item-shrink-0 item-flex-1 c-171A1D font-28 text-right fb fb-cross-center fb-main-end w-adapt-100"
        >
          <span
            class="text-ellipsis inline-block w-adapt-24"
            @click="handlerChangeClass"
          >
            {{ computedDeptName }}</span
          ><i class="iconfont font-24 c-171A1D ml-4" @click="handlerChangeClass"
            >&#xe648;</i
          >
        </div>
        <!-- 清空按钮 -->
        <div
          class="item-shrink-0 c-171A1D font-24 text-center ml-8"
          @click="clearClass"
          v-if="showClear && !!classData.length"
        >
          <i class="iconfont">&#xe727;</i>
        </div>
      </div>
      <!-- 报表 -->
      <div
        class="c-171A1D font-28 text-right fb fb-cross-center fb-main-end pr-16"
        v-show="showReports"
      >
        <span @click="handlerJumpReportsPage">
          <i class="iconfont mr-4 font-34">&#xe6a9;</i>报表
        </span>
      </div>
    </div>
    <!-- 日期选择器 -->
    <common-date-picker
      v-model="visible"
      ref="picker"
      v-if="showDatePicker"
      class="evaluation-date-picker"
      :visibleItemCount="5"
      :label-config="labelConfig"
      :default-index="defaultIndex"
      @confirm="getPickerDate"
      @init-date="initPickerDate"
      :campus-id="campusId"
      without-header
    ></common-date-picker>
  </div>
</template>

<script>
import { timeFormat, filterName } from '@/utils/comUtils'
import { RETURN_TYPE, WEEK_DAY } from '@/utils/constUtils'
import commonDatePicker from './commonDatePicker.vue'

export default {
  name: 'commonSelection',
  components: {
    commonDatePicker
  },
  props: {
    value: String,
    clearable: {
      type: Boolean,
      default: true
    },
    showClear: {
      type: Boolean,
      default: false
    },
    showBorder: {
      type: Boolean,
      default: true
    },
    showReports: {
      type: Boolean,
      default: false
    },
    selectType: {
      type: Number,
      default: 3
    },
    endType: {
      type: Number,
      default: 3
    },
    returnType: {
      type: Number,
      default: RETURN_TYPE.dingNode
    },
    labelConfig: {
      type: Object,
      default: () => {
        return {
          chooseDate: true,
          chooseWeek: false,
          chooseMonth: false,
          chooseTerm: false
        }
      }
    }
  },
  data() {
    return {
      date: '',
      week: '',
      showAction: false,
      classData: [],
      visible: false,
      showDatePicker: false,
      defaultIndex: [],
      campusId: this.$store.getters.currentCapmus.tpId,
      dateStr: '',
      dimDay: ''
    }
  },
  computed: {
    queryFilter() {
      return this.$store.getters.attendanceQueryFilter || null
    },
    computedIsWholeSchool() {
      return this.$store.getters.isWholeSchool
    },
    computedQueryFilterText() {
      return this.$store.getters.storeGettersFilterText
    },
    showDate() {
      if (!this.date) {
        return ''
      }
      let _showDate = ''
      let _date = this.date.replace(/-/gi, '.')
      let _now = timeFormat(new Date(), 'YYYY.MM.DD')
      if (_date === _now) {
        _showDate = '今天'
      } else {
        _date = _date.slice(5, 10)
        _showDate = `${_date} ${this.week}`
      }
      return _showDate
    },
    computedDeptName() {
      if (this.classData.length > 1) {
        return `${filterName(this.classData[0].deptName, 12)}等${
          this.classData.length
        }个部门`
      } else if (this.classData.length === 1) {
        return `${filterName(this.classData[0].deptName, 12)}`
      }
      return '全校'
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.init()
      }
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.showDatePicker = true
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    handlerChangeClass() {
      let _mSchoolAddressBook = {
        addressType: 2,
        role: 3,
        userId: this.dingUserId,
        corpId: this.corpId,
        appId: this.appId,
        corpName: this.corpName,
        selectType: this.selectType,
        endType: this.endType,
        returnType: this.returnType, // 返回魔点Id
        classList: [],
        multiple: true,
        campus: this.$store.getters.currentCapmus,
        canViewDetail: false
      }
      this.$addressList(_mSchoolAddressBook)
        .then(res => {
          // 直接返回 不更新数据
          if (!this.clearable) {
            if (res.$type === '') {
              return false
            }
          }
          this.classData = res.depts || []
          this.$emit('changeClass', this.classData)
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    // 清空班级选择
    clearClass() {
      this.classData = []
      this.$emit('clear-class', this.classData)
    },
    init() {
      // 初始化月统计日期
      this.methodUpdateDate(this.value)
      this.$emit('handlerIsResetFilter')
      this.$store.commit('attendanceMainDate', this.date)
    },
    // 选择日期
    handlerToSelectDate() {
      this.visible = true
    },
    methodUpdateDate(date) {
      let _date = date ? new Date(date) : new Date()
      this.date = timeFormat(_date, 'YYYY-MM-DD')
      this.week = WEEK_DAY[_date.getDay()]
    },
    handlerClearQueryFilter() {
      let prevDate = this.date
      this.$store.commit('setAttendanceQueryFilter', null)
      this.$store.commit('setAttendanceSelectDetailNodes', null)
      this.methodUpdateDate()
      let nextDate = this.date
      if (prevDate === nextDate) {
        this.$parent.initResetPage(true)
      } else {
        this.$emit('input', this.date)
      }
      // 重置操作 attendanceDetailComponents
      this.$emit('updateAttendanceDetail')
    },
    handlerJumpReportsPage() {
      this.$emit('handleReport')
    },
    // 初始化日期选择器
    initPickerDate({ activeIndex, dateStr, activeValue }) {
      this.handlerPickerData(
        { activeIndex, dateStr, activeValue },
        'initPickerDate'
      )
    },
    // 获取日期选择器选择的日期
    getPickerDate({ activeIndex, dateStr, activeValue }) {
      this.handlerPickerData(
        { activeIndex, dateStr, activeValue },
        'getPickerDate'
      )
    },
    // 处理日期选择器数据
    async handlerPickerData({ activeIndex, dateStr, activeValue }) {
      this.visible = false
      this.defaultIndex = activeIndex
      this.dateStr = dateStr
      this.dimDay = activeValue && activeValue.dimDay
      // 更新日期显示
      if (activeValue && activeValue.dimDay) {
        const selectedDate = new Date(
          Math.floor(activeValue.dimDay / 10000),
          Math.floor((activeValue.dimDay % 10000) / 100) - 1,
          activeValue.dimDay % 100
        )
        this.methodUpdateDate(selectedDate)
        this.$emit('date-click', this.date)
      }
    }
  },
  filters: {}
}
</script>

<style lang="scss" scoped>
.month-statics {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 13px;
}
.filter-condition {
  display: flex;
  align-items: center;
  &-clear {
    flex-basis: 32px;
    vertical-align: middle;
    text-align: center;
  }
}
</style>
